




























import {Component, Vue, Watch} from 'vue-property-decorator';
import { mapFields } from 'vuex-map-fields';
import ApiRoutes from '@/logic/ApiRoutes';
import Profile from '@/types/Profile';
import ApiHandler from '@/logic/ApiHandler';
import LanguageHandler from '@/localisation/LanguageHandler';
import WakeLockService from '@/components/functional/WakeLockService.vue';

interface ProfileOption {
  value: number;
  text: string;
  profile?: {
      language_id: string;
      [key: string]: any;
  };
}

@Component({
  computed: {
      ...mapFields('settings', [
          'profile',
          'show_timestamps',
          'show_media',
          'order_top_first',
          'performance_display_type',
          'large_text',
          'wakeLockEnabled',
          'text_size',
      ]),
  },
})
export default class Settings extends Vue {


  // Placeholders for if the actual profiles can't be retrieved
  private availableProfiles: ProfileOption[] = [
      { value: -1, text: "English", profile: {
          language_id: "30"
      }},
      { value: -2, text: "Deutsch", profile: {
          language_id: "43"
      }}
  ];

  private performanceDisplayTypes = [
      { value: 0, text: this.$t('settings.display-inline') },
      { value: 1, text: this.$t('settings.display-sticky') }
  ];

  @Watch('profile') private onProfileChange(newVal, oldVal) {

      // Log analytics
      this.$store.commit('analytics/registerSettingChange', {
          setting: 'profile', oldValue: oldVal, newValue: newVal });

      // Get profile object
      const obj = this.availableProfiles.find((el) => el.value === newVal)!.profile;

      // Get localisation code
      const localeCode = LanguageHandler.getLocalisationCode(obj!.language_id);

      if (localeCode) {
          this.$store.dispatch('settings/setLocale', localeCode);
      }
  }

  // Watchers for analytics
  @Watch('dark_mode') private onDarkModeChange(newVal, oldVal) {
      this.$store.commit('analytics/registerSettingChange', {
          setting: 'dark_mode', oldValue: oldVal, newValue: newVal }); }
  @Watch('show_timestamps') private onShowTimestampsChange(newVal, oldVal) {
      this.$store.commit('analytics/registerSettingChange', {
          setting: 'show_timestamps', oldValue: oldVal, newValue: newVal }); }
  @Watch('show_media') private onShowMediaChange(newVal, oldVal) {
      this.$store.commit('analytics/registerSettingChange', {
          setting: 'show_media', oldValue: oldVal, newValue: newVal }); }
  @Watch('order_top_first') private onOrderTopFirstChange(newVal, oldVal) {
      this.$store.commit('analytics/registerSettingChange', {
          setting: 'order_top_first', oldValue: oldVal, newValue: newVal }); }
  @Watch('performance_display_type') private onPerformanceDisplayTypeChange(newVal, oldVal) {
      this.$store.commit('analytics/registerSettingChange', {
          setting: 'performance_display_type', oldValue: oldVal, newValue: newVal }); }

  private created() {
      if (this.$store.getters['settings/inPerformance']) {
          this.fetchProfiles();
      }
  }

  get wakelockAvailable(): boolean {
      return this.$store.getters['settings/getWakeLockAvailable'];
  }

  get dark_mode(): boolean {
      return this.$store.getters['settings/isDarkMode'];
  }

  set dark_mode(val: boolean) {
      this.$store.dispatch('settings/setDarkMode', val);
  }
  get font_size(): number {
    return this.$store.getters['settings/font_size'];
  }
  // Get list of profile options to choose from
  private async fetchProfiles() {
      const performance = this.$store.getters['settings/getPerformance'];
      const request = ApiRoutes.getProfilesRequest(performance);

      const data: any[] = await ApiHandler.request(request);
      const list: ProfileOption[] = [];

      // Set select-element data
      data.forEach((element: any) => {
          list.push({
              value: parseInt(element.profile_id, 10),
              text: element.title,
              profile: element
          });
      });

      // Apply
      if (list.length > 0) {
          this.availableProfiles = list;
      }
  }
}
